import { getApartmentTypeCounts as o } from "../../metrics/apartment-distribution/index2.js";
function e(t) {
  return o(t);
}
export {
  e as getStoryDistributionTotals
};
//# sourceMappingURL=index4.js.map
